var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColissimo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53948 7.14044C9.47525 7.17822 9.37325 7.17444 9.31091 7.13666L8.93878 6.91565C8.90855 6.89676 8.88022 6.86654 8.85944 6.83065C8.85755 6.82876 8.85755 6.82687 8.85566 6.82498C8.8311 6.7872 8.81788 6.74564 8.81788 6.70786L8.80844 6.27528C8.80655 6.20161 8.85377 6.11282 8.918 6.07504L13.3836 3.47388L7.11777 0.0566702C7.04788 0.0188901 6.95721 0 6.86654 0C6.77586 0 6.6833 0.0188901 6.6153 0.0566702L0.347577 3.47199L7.36901 7.5598C7.43324 7.59569 7.48424 7.6807 7.48424 7.75626V13.7199C7.48424 13.7954 7.43135 13.8804 7.36523 13.9163L6.98743 14.126C6.95532 14.143 6.91565 14.1524 6.87409 14.1524C6.8722 14.1524 6.86843 14.1524 6.86654 14.1524C6.8212 14.1543 6.77964 14.1449 6.74564 14.126L6.36595 13.9144C6.30172 13.8804 6.24883 13.7935 6.24883 13.718V8.4023C6.24505 8.36263 6.21672 8.3154 6.18649 8.2984L0 4.69796V11.7515C0 11.9102 0.111451 12.1048 0.24746 12.1841L6.61908 15.9413C6.68708 15.981 6.77775 16.0018 6.86654 15.9999C6.95532 15.9999 7.04599 15.981 7.114 15.9413L13.4856 12.1841C13.6216 12.1029 13.7331 11.9102 13.7331 11.7515V4.69796L9.53948 7.14044Z",
    fill: "url(#paint0_linear_2683_68745)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2683_68745",
    x1: 0.159434,
    y1: 12.0225,
    x2: 13.3728,
    y2: 3.82034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#ED6C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3875,
    stopColor: "#EF7A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6356,
    stopColor: "#F39107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#F9AF06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBA07"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColissimo);
export default __webpack_public_path__ + "static/media/colissimo.1f706c015c29cd61f797b10a22e43696.svg";
export { ForwardRef as ReactComponent };